"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectCondition = void 0;
const PropertyCondition_1 = require("./PropertyCondition");
class ObjectCondition extends PropertyCondition_1.PropertyCondition {
    constructor(property, itemConditions) {
        super(property);
        this.itemConditions = itemConditions;
    }
    setOptions(options) {
        this.options = options;
        this.itemConditions.forEach((condition) => {
            condition.setOptions(options);
        });
    }
    isFulfilled(value) {
        const superResult = super.checkProperty(value);
        if (superResult.isFinal) {
            return superResult.result;
        }
        const isObject = typeof (value[this.property]) === "object" && !(value[this.property] instanceof Array);
        if (!isObject) {
            return this.createUnfulfilledResult(value, "is not an object");
        }
        const result = { fulfilled: true, reasons: [] };
        const checkForSuperfluousProperties = this.options && !this.options.ignoreSuperfluousObjectProperties;
        const definedProperties = [];
        this.itemConditions.forEach((condition) => {
            const property = condition.getProperty();
            if (checkForSuperfluousProperties && value[this.property].hasOwnProperty(property)) {
                definedProperties.push(property);
            }
            const itemResult = condition.isFulfilled(value[this.property]);
            if (!itemResult.fulfilled) {
                result.fulfilled = false;
                if (itemResult.reasons) {
                    result.reasons = result.reasons.concat(this.prefixPaths(itemResult.reasons));
                }
            }
        });
        if (checkForSuperfluousProperties) {
            const superfluousKeys = Object.keys(value[this.property]).filter((key) => !definedProperties.includes(key));
            if (superfluousKeys.length > 0) {
                result.fulfilled = false;
                result.reasons = superfluousKeys.map((key) => {
                    return {
                        path: this.property + "." + key,
                        value: value[this.property][key],
                        explanation: "is not defined here",
                    };
                });
            }
        }
        return result.fulfilled ? { fulfilled: true } : result;
    }
    prefixPaths(reasons) {
        return reasons.map((reason) => {
            reason.path = this.property + "." + reason.path;
            return reason;
        });
    }
}
exports.ObjectCondition = ObjectCondition;
//# sourceMappingURL=ObjectCondition.js.map